import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';

interface DeleteDialogProps {
  isOpen: boolean;
  onChangeOpen: (open: boolean) => void;
  onConfirm?: () => void;
}

export default function DeleteDialog({
  isOpen,
  onChangeOpen,
  onConfirm,
}: DeleteDialogProps) {
  return (
    <Dialog open={isOpen}>
      <DialogContent className="sm:max-w-[600px]">
        <DialogHeader>
          <DialogTitle>Are you sure?</DialogTitle>
          <DialogDescription>This will delete the poll.</DialogDescription>
        </DialogHeader>

        <DialogFooter>
          <Button
            onClick={() => {
              onChangeOpen(false);
            }}
            variant={'secondary'}
            type="button"
          >
            Cancel
          </Button>
          <Button
            onClick={async () => {
              onConfirm?.();

              onChangeOpen(false);
            }}
            variant={'destructive'}
            type="button"
          >
            Delete
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
